import { FetchBusinessUnitTradeMappingsResponse } from "./types";
import axiosInstance from "../axiosInstance";

export const fetchBusinessUnitTradeMappings = async (
  companyUuid: string,
): Promise<FetchBusinessUnitTradeMappingsResponse> => {
  const response =
    await axiosInstance.get<FetchBusinessUnitTradeMappingsResponse>(
      `/api/private/companies/${companyUuid}/service-titan/business-units/trade-mappings`,
    );
  return response.data;
};
